import { PushNotifications } from '@capacitor/push-notifications'
import { getRjmStateChangeObj, useUserManagementClientStoreStore } from '../stores/saasUserManagementClientStore'
import saasApiClientServerRequestQueue from '../saasApiClientServerRequestQueue'

import mainLayoutCommon from '../layouts/common.js'
import { removePusher, registerPushToken } from './capicatorDetectBothMobile.js'
import { Notify } from 'quasar'

let pushListeners = []

async function registerForPushNotifications (matrixClient, asynccallbackTokenFn) {
  // console.log('RJMDEBUG001 registering push notification listeners')

  await removeAllPushListners()

  pushListeners.push(PushNotifications.addListener('registration', async (token) => {
    console.log('RJMDEBUG200 Push token received:', token.value)
    await registerPushToken({ matrixClient, tokenValue: token.value })
    await asynccallbackTokenFn({ tokenValue: token.value })
  }))

  pushListeners.push(PushNotifications.addListener('registrationError', (err) => {
    console.error('RJMDEBUG200 Push registration error:', err)
  }))

  // When a notification is tapped
  pushListeners.push(PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    console.log('RJMDEBUG200 Notification action performed', action)
    const roomId = action.notification.data?.notification?.room_id

    if (roomId) {
      console.log('RJMDEBUG200 Navigating to room:', roomId)
      // Assuming you use Vue Router (Quasar), this might look like:
      // router.push({ name: 'chat', params: { roomId } })
    } else {
      console.log('RJMDEBUG200 ERROR No room_id found in push notification.')
    }
  }))

  // console.log('RJMDEBUG001 registerForPushNotifications about to request permissions')
  PushNotifications.requestPermissions().then(permStatus => {
    if (permStatus.receive === 'granted') {
      console.log('RJMDEBUG200 Sucessfully granted push notification permission')
    } else {
      console.log('RJMDEBUG200 ERROR Push permission not granted.')
      return
    }
    (async () => {
      console.log('RJMDEBUG200 Registiring push notifications async')
      await PushNotifications.register()
    })()
  }).catch(error => {
    console.log('RJMDEBUG200 Error requesting push permissions:', error)
  })
}

async function removeAllPushListners () {
  for (const listener of pushListeners) {
    await listener.remove()
  }

  pushListeners = []
}

async function notifyMatrixConnectionDetails (connectionDetails) {
  const plugin = window.Capacitor.Plugins.FirebasePushToken
  if (!plugin) {
    console.log('RJMDEBUG200 FirebasePushToken plugin not available')
    console.log('RJMDEBUG200 Plugins:', window.Capacitor.Plugins)
  } else {
    plugin.receiveMatrixConnectionDetails(connectionDetails)
  }
}

async function notifyMatrixLogout (matrixClient) {
  await removeAllPushListners()

  const plugin = window.Capacitor.Plugins.FirebasePushToken
  if (!plugin) {
    console.log('RJMDEBUG200 FirebasePushToken plugin not available notifyMatrixLogout')
  } else {
    await removePusher(matrixClient, plugin)
    await plugin.notifyMatrixLogout()
  }
}

function transmitMessage ({ txnId, processData, roomId, messageType, content, matrix, globalEventBus }) {
  const plugin = window.Capacitor.Plugins.TransmissionExecutor
  if (!plugin) {
    console.log('RJMDEBUG200 ERROR TransmissionExecutor plugin not available')
    console.log('RJMDEBUG200 Plugins:', window.Capacitor.Plugins)
  } else {
    plugin.transmitMessage({ txnId, processData, roomId, messageType, content })
  }
}

async function handleLoginClick ({ userDetailsStore, chatStore, bus, router, tenantName, matrix, configuredLoginUrl, returnAddress }) {
  const plugin = window.Capacitor.Plugins.CapacitorAuth
  if (!plugin) {
    console.log('RJMDEBUG200 ERROR ios CapacitorAuthPlugin plugin not available')
    console.log('RJMDEBUG200 Plugins:', window.Capacitor.Plugins)
    return false
  }
  const result = await plugin.startAuthentication({ configuredLoginUrl, returnAddress })
  if (result.cancelled) {
    return false
  }
  const callbackUrl = new URL(result.callbackUrl)
  const jwtretervialtoken = callbackUrl.searchParams.get('jwtretervialtoken')

  const callback = {
    ok: function (response) {
      const userManagementClientStore = useUserManagementClientStoreStore()
      // console.log('userManagementClientStore', userManagementClientStore, userDetailsStore, chatStore)
      // console.log('sss', mainLayoutCommon, Notify)
      mainLayoutCommon.refreshAllStores({
        bus,
        Notify,
        userManagementClientStore,
        userDetailsStore,
        router,
        tenantName,
        chatStore,
        matrix
      })
    },
    error: function (response) {
      console.log('RJMDEBUG200 ERROR ios CapacitorAuthPlugin process recieved token failed')
    }
  }
  const rjmStateChange = getRjmStateChangeObj()
  const routePath = callbackUrl.searchParams.get('route')

  await rjmStateChange.executeAction('processRecievedJWTretervialtoken', {
    jwtretervialtoken,
    callback,
    curpath: routePath,
    startAllBackendCallQueuesFn: saasApiClientServerRequestQueue.getStartAllBackendCallQueuesFn({ curpath: routePath })
  })

  return false
}

export default {
  registerPushToken,
  registerForPushNotifications,
  notifyMatrixConnectionDetails,
  notifyMatrixLogout,
  transmitMessage,
  handleLoginClick
}
